import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { AppContext } from "../../context/AppContext";


function MechProduct({ item, grid }) {
  return (
    <div className="product-layout col-lg-4 col-md-4 col-sm-6 col-xs-12">
      <div className="product-item-container item--static">
        <div className="left-block">
          <div className="product-image-container second_img">
            <div
              title={item?.user?.first_name + " " + item?.user?.last_name}
              className="img-hold"
            >
              <Link to={`/mechanic/${item.id}`}>
                <img
                  src={item?.user?.avatar || "/image/mechanic.png"}
                  className="img-1 img-responsive"
                  alt="image1"
                />
                <img
                  src={item?.user?.avatar || "/image/mechanic.png"}
                  className="img-2 img-responsive"
                  alt="image2"
                />
              </Link>
            </div>

          </div>
          <div className="mt-4" style={{ marginTop: 10 }}></div>

          {grid && (
            <div className="container">
              <div className="row">
                <div className="" style={{ padding: 10, width: "290px" }}>
                  <p>
                    <strong>Name:</strong> {item?.user?.first_name} {item?.user?.last_name}
                  </p>
                  <p>
                    <strong>Specialization:</strong> {item?.specialization}
                  </p>

                  <strong style={{ minWidth: "100px" }}>Address:</strong>
                  <span style={{ minWidth: "100px" }}> {item?.address?.address}</span>




                  <p>
                    <strong>Phone:</strong> {item?.user?.phone_number}
                  </p>
                  <a
                    href={`tel:${item?.user?.phone_number}`}
                    className="btn btn-danger mt-2"
                    style={{ backgroundColor: "#FF2D37", borderRadius: 20 }}
                  >
                    Call Now
                  </a>
                </div>
              </div>
            </div>
          )}

          <span className="label-product label-new">
            {item?.specialization}
          </span>

          {/*quickview*/}
          <div className="so-quickview">
            <div
              className="iframe-link btn-button quickview quickview_handler visible-lg"
              title="Quick view"
              data-fancybox-type="iframe"
            >
              <i className="fa fa-phone" />
              <span>Call Now</span>
            </div>
          </div>
          {/*end quickview*/}
        </div>

        <div className="right-block">


          <div className="description item-desc">
            <p>
              <strong>Name:</strong> {item?.user?.first_name} {item?.user?.last_name}
            </p>
            <p>
              <strong>Specialization:</strong> {item?.specialization}
            </p>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                flexWrap: "wrap",
                gap: "4px",
                alignItems: "flex-start",
                wordBreak: "break-word",
                whiteSpace: "normal",
                overflowWrap: "break-word",
                width: "100%",
              }}
            >
              <strong style={{ minWidth: "100px" }}>Address:</strong>
              <span style={{ flex: 1 }}>{item?.address?.address}</span>
            </div>


            <p>
              <strong>Phone:</strong> {item?.user?.phone_number}
            </p>
            {/* ✅ Call Now button */}
            {item?.user?.phone_number && (
              <a
                href={`tel:${item?.user?.phone_number}`}
                className="btn btn-danger mt-2"
                style={{
                  display: "inline-block",
                  marginTop: "10px",
                  padding: "8px 16px",
                  backgroundColor: "red",
                  color: "#fff",
                  borderRadius: "5px",
                  textDecoration: "none"
                }}
              >
                📞 Call Now
              </a>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default MechProduct;


